module.exports = __webpack_public_path__ + "static/Aston-20187_ourbqo-bb51d0600042bc62561b39d5db554e30.jpg";